import React from 'react'
import './spinner.sass'

const Spinner = () => {
    return (
        <div className="lds-ringLogin">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    )
}

export default Spinner
